import client from '@/api/base';

export default {
// Stakeholders
  async getStakeholders() {
    const response = await client.get('coaching/supporter/');
    return response;
  },

  async createStakeholder(data) {
    const response = await client.post('coaching/supporter/', data);
    return response;
  },

  async publishStakeholders() {
    const response = await client.post('coaching/supporter/confirm/');
    return response;
  },

  async updateStakeholder(id, data) {
    const response = await client.patch(`coaching/supporter/${id}/`, data);
    return response;
  },

  async deleteStakeholder(id) {
    const response = await client.delete(`coaching/supporter/${id}/`);
    return response;
  },

  // Supporter Opt-Out
  async getOptSupporterFull(id) {
    const response = await client.get(`coaching/supporter/${id}/`);
    return response;
  },

  async getOptSupporter(id) {
    const response = await client.get(`coaching/supporter/${id}/opt-out/`);
    return response;
  },

  async submitOptOut(id, data) {
    const response = await client.post(`coaching/supporter/${id}/opt-out/`, data);
    return response;
  },

  // unlisted support
  async getSupporter() {
    const response = await client.get('engagement/leader/supporter/');
    return response;
  },

  async addSupporter(data) {
    const response = await client.post('engagement/leader/supporter/', data);
    return response;
  },

  async deleteSupporter(id) {
    const response = await client.delete(`supporter/${id}/`);
    return response;
  },
};
